import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Importa o CSS global (incluindo Tailwind)
import App from './App'; // Importa o componente principal App

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Comentários de orientação sobre configuração do servidor podem permanecer,
// mas não repita imports ou código React. O arquivo está correto para build.

// Solução para erro de rota ao atualizar páginas não-iniciais:
// 1. Certifique-se de que o servidor (por exemplo, nginx, Apache, ou o servidor de desenvolvimento) está configurado para redirecionar todas as rotas para o index.html.
// 2. Para projetos React criados com create-react-app, adicione a seguinte configuração no arquivo public/_redirects (caso use Netlify) ou configure o servidor para fallback em index.html.
// 3. Se estiver usando apenas o servidor de desenvolvimento do React, não é necessário alterar este arquivo JS. O problema é de configuração do servidor, não do código React.

// Exemplo de configuração para Netlify (crie o arquivo public/_redirects):
// /*    /index.html   200

// Exemplo de configuração para Apache (.htaccess):
// RewriteEngine On
// RewriteBase /
// RewriteRule ^index\.html$ - [L]
// RewriteCond %{REQUEST_FILENAME} !-f
// RewriteCond %{REQUEST_FILENAME} !-d
// RewriteRule . /index.html [L]

// Exemplo de configuração para nginx:
// location / {
//   try_files $uri /index.html;
// }

// O erro de "página não encontrada" ao atualizar páginas internas é causado por configuração do servidor, não pelo código React.
// Para corrigir, configure o servidor para redirecionar todas as rotas para index.html (fallback).
// Exemplo para Netlify: crie public/_redirects com: /*    /index.html   200
// Exemplo para Apache (.htaccess): use RewriteRule . /index.html [L]
// Exemplo para nginx: location / { try_files $uri /index.html; }
